export class AuthStateUtils {
  /**
   * Flag to track if a user has just authenticated
   * Used to distinguish between post-login flow and direct login page access
   */
  public static isFreshAuthentication = false;
}
